"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-userbox"
  }, [_vm.whoisLoading ? _c('div', {
    staticClass: "app-userbox-loading"
  }, [_c('i', {
    staticClass: "fa fa-spin fa-spinner",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : [_vm.isSelf ? _c('span', {
    staticClass: "app-userbox-selfprofile"
  }, [_vm._v(" " + _vm._s(_vm.$t('user_you')) + " ")]) : _vm._e(), _c('div', {
    staticClass: "app-userbox-header"
  }, [_c('div', {
    staticClass: "app-userbox-avatar"
  }, [_c('UserAvatar', {
    attrs: {
      "user": _vm.user,
      "network": _vm.network,
      "size": "large"
    }
  })], 1), _c('div', {
    staticClass: "app-userbox-userinfo"
  }, [_c('span', {
    staticClass: "app-userbox-nick"
  }, [_vm._v(_vm._s(_vm.user.nick))]), _vm.userMode ? _c('span', {
    staticClass: "app-userbox-modestring"
  }, [_vm._v("+" + _vm._s(_vm.userMode))]) : _vm._e(), _c('span', {
    staticClass: "app-userbox-usermask"
  }, [_vm._v(_vm._s(_vm.user.username) + "@" + _vm._s(_vm.user.host))])])]), _vm.aslMetaLine ? _c('div', {
    staticClass: "app-nicklist-user-meta app-userbox-asl"
  }, [_vm.aslAge ? _c('span', {
    staticClass: "app-nicklist-user-meta-item"
  }, [_vm._v(_vm._s(_vm.aslAge))]) : _vm._e(), _vm.aslSexLabel ? _c('span', {
    staticClass: "app-nicklist-user-meta-item",
    class: `app-nicklist-user-meta-sex app-nicklist-user-meta-sex--${_vm.aslSexClass}`
  }, [_vm._v(_vm._s(_vm.aslSexLabel))]) : _vm._e(), _vm.aslLocation ? _c('span', {
    staticClass: "app-nicklist-user-meta-item app-nicklist-user-meta-location"
  }, [_vm._v(_vm._s(_vm.aslLocation))]) : _vm._e()]) : _vm.realname ? _c('div', {
    staticClass: "app-userbox-basicinfo"
  }, [_c('span', {
    staticClass: "app-userbox-basicinfo-title"
  }, [_vm._v(_vm._s(_vm.$t('whois_realname')) + ":")]), _c('span', {
    staticClass: "app-userbox-basicinfo-data",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedRealname)
    }
  })]) : _vm._e(), _vm.commonChannels.length ? _c('div', {
    staticClass: "app-userbox-chans"
  }, [_c('div', {
    staticClass: "app-userbox-chans-title"
  }, [_vm._v("Salon(s) commun(s)")]), _c('div', {
    staticClass: "app-userbox-chans-list"
  }, _vm._l(_vm.commonChannels, function (chan) {
    return _c('a', {
      key: chan.name,
      staticClass: "app-userbox-chan app-userbox-chan--common",
      on: {
        "click": function ($event) {
          return _vm.joinChannel(chan.name);
        }
      }
    }, [_vm._v(_vm._s(chan.name))]);
  }), 0)]) : _vm._e(), _c('div', {
    staticClass: "app-userbox-actions"
  }, [!_vm.isSelf && !_vm.buffer.isQuery() ? _c('a', {
    staticClass: "app-userbox-action app-userbox-action--full",
    on: {
      "click": _vm.openQuery
    }
  }, [_c('i', {
    staticClass: "fa fa-comment-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("Message privé")])]) : _vm._e(), !_vm.isSelf ? _c('button', {
    staticClass: "app-userbox-action app-userbox-blockbtn",
    class: {
      'app-userbox-blockbtn--active': _vm.user.ignore
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        _vm.user.ignore = !_vm.user.ignore;
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.user.ignore ? 'fa-check-circle' : 'fa-ban',
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.user.ignore ? 'Débloquer' : 'Bloquer'))])]) : _vm._e(), _vm._l(_vm.pluginUiButtonElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      attrs: {
        "plugin-props": {
          user: _vm.user,
          userbox: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "user": _vm.user,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  })], 2), _vm.pluginUiWhoisElements.length || _vm.otherChannels.length ? _c('div', {
    staticClass: "app-userbox-whois"
  }, [_vm.pluginUiWhoisElements.length ? _vm._l(_vm.pluginUiWhoisElements, function (plugin) {
    return _c(plugin.component, _vm._b({
      key: plugin.id,
      tag: "component",
      attrs: {
        "plugin-props": {
          user: _vm.user,
          userbox: _vm.self
        },
        "network": _vm.network,
        "buffer": _vm.buffer,
        "user": _vm.user,
        "sidebar-state": _vm.sidebarState
      }
    }, 'component', plugin.props, false));
  }) : [_c('div', {
    staticClass: "app-userbox-chans-title"
  }, [_vm._v("Également sur les salons")]), _c('div', {
    staticClass: "app-userbox-chans-list"
  }, _vm._l(_vm.otherChannels, function (chan) {
    return _c('a', {
      key: chan.name,
      staticClass: "app-userbox-chan",
      on: {
        "click": function ($event) {
          return _vm.joinChannel(chan.name);
        }
      }
    }, [_vm._v(_vm._s(chan.name))]);
  }), 0)]], 2) : _vm._e(), _vm.buffer.isChannel() && _vm.areWeAnOp && !_vm.isSelf ? _c('div', {
    staticClass: "app-userbox-opactions"
  }, [_c('form', {
    staticClass: "u-form",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm.isUserOnBuffer ? _c('label', [_vm._v(" " + _vm._s(_vm.$t('user_access')) + " "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userMode,
      expression: "userMode"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.userMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_vm._l(_vm.availableChannelModes, function (mode) {
    return _c('option', {
      key: mode.mode,
      domProps: {
        "value": mode.mode
      }
    }, [_vm._v(" " + _vm._s(mode.description) + " ")]);
  }), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Utilisateur")])], 2)]) : _vm._e(), _vm.isUserOnBuffer ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary app-userbox-opaction-kick app-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.buffer.kickUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_kick')) + " ")])]) : _vm._e(), _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary app-userbox-opaction-ban app-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.buffer.banUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ban",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_ban')) + " ")])]), _vm.isUserOnBuffer ? _c('label', [_c('button', {
    staticClass: "u-button u-button-secondary app-userbox-opaction-kickban app-userbox-opaction",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.buffer.banKickUser(_vm.user);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('user_kickban')) + " ")])]) : _vm._e()])]) : _vm._e()]], 2);
};
var staticRenderFns = exports.staticRenderFns = [];